<template>
  <div
    v-if="userEnsured"
    class="anz-wrapper"
    :class="{ 'anz-dark-mode': configuration.widget.darkModeEnabled }"
  >
    <div class="anz-container">
      <icons-sprite></icons-sprite>
      <error-page v-if="appError" />
      <technical-shutdown v-else-if="viewType === WIDGET_DISABLED" />
      <Suspense v-else-if="viewType === PROFILE">
        <template #default>
          <UserProfile />
        </template>
        <template #fallback>
          <a-loader class-name="my-l" />
        </template>
      </Suspense>
      <post-simple-list v-else-if="viewType === TOP_NEWEST" />
      <post-list v-else-if="topic" />
    </div>
  </div>

  <teleport
    v-if="
      configuration.widget.showProfileCrossroads && viewType !== WIDGET_DISABLED
    "
    to="#anzu-forum-widget-profile"
  >
    <div
      class="anz-wrapper"
      :class="{ 'anz-dark-mode': configuration.widget.darkModeEnabled }"
    >
      <div class="anz-container">
        <ProfileCrossroads></ProfileCrossroads>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconsSprite from '@/components/IconsSprite.vue'
import ALoader from '@/components/ALoader.vue'
import useConfiguration from './composables/configuration/configuration'
import useCurrentUser from '@/composables/user/user'
import useAppState, { ViewType } from '@/composables/ui/ui'
import ProfileCrossroads from '@/components/Profile/ProfileCrossroads.vue'
import ErrorPage from '@/components/ErrorPage.vue'
import useTopic from '@/composables/topic/topic'
import UserProfile from '@/components/Profile/UserProfile.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import PostList from '@/components/Post/PostList.vue'
import PostSimpleList from '@/components/Post/PostSimpleList.vue'
import useScrollManager from '@/composables/scroller/useScrollManager'

// eslint-disable-next-line @typescript-eslint/camelcase
declare let __webpack_public_path__: string

export default defineComponent({
  name: 'App',
  components: {
    PostSimpleList,
    TechnicalShutdown,
    ErrorPage,
    ProfileCrossroads,
    PostList,
    UserProfile,
    IconsSprite,
    ALoader,
  },
  data() {
    return {
      PROFILE: ViewType.PROFILE,
      TOP_NEWEST: ViewType.TOP_NEWEST,
      PROFILE_USER_EDIT: ViewType.PROFILE_USER_EDIT,
      PROFILE_EMAIL_EDIT: ViewType.PROFILE_EMAIL_EDIT,
      WIDGET_DISABLED: ViewType.WIDGET_DISABLED,
    }
  },
  setup() {
    const {
      currentUser,
      isLoggedIn,
      isSubscriber,
      allowPayingCustomerAction,
      userEnsured,
    } = useCurrentUser()
    const { ensureCurrentUser } = useCurrentUser()
    const { configuration } = useConfiguration()

    ensureCurrentUser()
    const { loadTopic, topic } = useTopic()

    if (configuration.widget.topicId > 0) {
      loadTopic()
    }

    useScrollManager()

    let publicPath = configuration.envConf.widgetUrl
    if (process.env.VUE_APP_VERSION) {
      publicPath += process.env.VUE_APP_VERSION + '/'
    }
    // eslint-disable-next-line @typescript-eslint/camelcase,prefer-const
    __webpack_public_path__ = publicPath

    return {
      currentUser,
      configuration,
      isLoggedIn,
      allowPayingCustomerAction,
      isSubscriber,
      userEnsured,
      topic,
      ...useAppState(),
    }
  },
})
</script>

<style lang="scss">
@import './assets/styles/style.scss';
</style>
